export const createComponentId = (reportType: string | undefined): string => {
  return `${reportType ?? 'default'}-component`;
};
